<!-- Navigation Menu -->
<p-menubar [model]="menuItems" *ngIf="isAuthenticated">
  <ng-template pTemplate="start">
    <div class="app-logo">
      <i class="pi pi-building" style="font-size: 1.5rem; color: var(--primary-color);"></i>
      <span class="app-title">Travvise Tenant Portal</span>
    </div>
  </ng-template>
  <ng-template pTemplate="end">
    <app-user-menu></app-user-menu>
  </ng-template>
</p-menubar>

<!-- Main Application with Page Transitions -->
<div class="app-content">
  <router-outlet #outlet="outlet"></router-outlet>
</div>


